<template>
  <!--<Home msg="Welcome to Your Vue.js App" />-->
  <transition name="fade" mode="out-in">
    <router-view />
  </transition>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
//import Home from "./components/Home.vue";

export default {
  name: "App",
  components: {
    //Home,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

/* Import font & reset default style */
@import url("https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700");

/* Animasi saat ganti halaman */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Pastikan layout menyesuaikan template kamu */
html,
body,
#app {
  margin: 0;
  padding: 0;
  font-family: "Open Sans", sans-serif;
  background-color: #fff;
  color: #333;
}

a {
  text-decoration: none;
  color: inherit;
}
</style>
